module.exports = __webpack_public_path__ + "static/media/home-news-img3.b52106a2.jpg";